export * from '@primeuix/themes/aura/inplace';
export { default } from '@primeuix/themes/aura/inplace';
